import React from 'react'
import PropTypes from 'prop-types'
import { IconButton } from 'pcln-design-system'
import { RadioMinus, RadioPlus } from 'pcln-icons'

class ControlIcon extends React.Component {
  static propTypes = {
    iconName: PropTypes.string.isRequired,
    travelerType: PropTypes.string.isRequired,
    updateTravelerCount: PropTypes.func.isRequired,
    isIncrement: PropTypes.bool.isRequired,
    isDisabled: PropTypes.bool
  }

  static defaultProps = {
    isIncrement: false,
    updateTravelerCount: () => {}
  }

  handleClick = () => {
    const {
      isDisabled,
      updateTravelerCount,
      travelerType,
      isIncrement
    } = this.props

    if (!isDisabled && updateTravelerCount) {
      updateTravelerCount(travelerType, isIncrement)
    }
  }

  render () {
    const { iconName, isDisabled, travelerType } = this.props
    // TODO: improve to use the pass-through props pattern to retain the prop
    //       name as "iconName" (avoid edit as like "name" as prop name)

    let iconButtonID = ''
    let ariaLabel = ''
    const travelerLabel = travelerType.toLowerCase()
    const disabled = isDisabled ? ' - disabled' : ''

    if (iconName === 'radioMinus') {
      iconButtonID = `traveler-selection-${travelerLabel}-minus-button`
      ariaLabel = `Decrease ${travelerLabel}${disabled}`
    } else {
      iconButtonID = `traveler-selection-${travelerLabel}-plus-button`
      ariaLabel = `Increase ${travelerLabel}${disabled}`
    }

    const RadioIcon = iconName === 'radioMinus' ? RadioMinus : RadioPlus
    return (
      <IconButton
        id={iconButtonID}
        icon={<RadioIcon size={24} color={isDisabled ? 'border' : 'primary'} />}
        size={24}
        onClick={this.handleClick}
        style={{ cursor: 'pointer' }}
        aria-label={ariaLabel}
        aria-controls={`${travelerType}-number`}
      />
    )
  }
}

// TODO: ControlIcon should be unnecessary at all since it's essentially a
//       different version of the IconButton component. Follow-up to clean
//       up in a later task per PR review comment.
ControlIcon.displayName = 'ControlIcon'

export default ControlIcon
